export default {
  pallets: [],
  pallet: undefined,
};
